module.exports = __webpack_public_path__ + "0840c1c03b194f27ece21a26f468f24a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/s/s16.jpg
// module id = 692
// module chunks = 0